import { Button, Flex } from "antd";
import { useState } from "react";
import { FilterIcon } from "../../assets";
import ButtonSwitch from "../../components/ButtonSwitch";
import { Popup } from "../../components";
import FilterForm from "../../forms/FilterForm";
import { usePopup } from "../../hooks/usePopup";
import AppliedFilter from "../../forms/AppliedFilter";
import FinancePublicTable from "./FinancePublicTable";
import FinanceTable from "./FinanceTable";
import { useAppSelector } from "../../redux/hooks";
import { getFinanceState } from "../../redux/store/getState";

const buttons = ["ATC Admin", "Public Users"];

export default function Finance() {
  const [activeButton, setActiveBtn] = useState<string | null>(null);
  const popup = usePopup();
  const { total_requested_vouchers, total_used_vouchers } =
    useAppSelector(getFinanceState);

  return (
    <>
      <Flex gap="large" wrap="wrap">
        <ButtonSwitch
          buttons={buttons}
          onSwitch={(activeButton: string) => setActiveBtn(activeButton)}
        />
        <Popup
          ref={popup.popupRef}
          openTrigger={
            <Button icon={<FilterIcon style={{ marginTop: 2 }} />}>
              Filter
            </Button>
          }
        >
          <FilterForm popup={popup} />
        </Popup>
        <AppliedFilter />
        <Button type="primary" style={{ backgroundColor: "#533031" }}>
          Total Requested Voucher: {total_requested_vouchers}
        </Button>
        <Button type="primary" style={{ backgroundColor: "#533031" }}>
          Total Used Vouchers: {total_used_vouchers}
        </Button>
      </Flex>
      {activeButton === "Public Users" ? (
        <FinancePublicTable />
      ) : (
        <FinanceTable />
      )}
    </>
  );
}
